import { render, staticRenderFns } from "./mingXi.vue?vue&type=template&id=fe86b870&scoped=true&"
import script from "./mingXi.vue?vue&type=script&lang=js&"
export * from "./mingXi.vue?vue&type=script&lang=js&"
import style0 from "./mingXi.vue?vue&type=style&index=0&id=fe86b870&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe86b870",
  null
  
)

export default component.exports